(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-video-section]');

    sections.forEach((section) => {
      const media = section.querySelector('.video-section__media');
      const playButton = section.querySelector('[data-play-button]');
      const video = section.querySelector('.video-section__video');
      const externalHolder = section.querySelector('[data-external-video]');
      const lazyLoad = section.dataset.lazyLoad === 'true';
      const showOverlay = section.dataset.showOverlay === 'true';

      const hideOverlay = () => {
        if (media) {
          media.classList.add('video-section__media--is-playing');
        }
      };

      const loadExternalVideo = () => {
        if (!externalHolder || externalHolder.dataset.loaded === 'true') {
          return;
        }

        const template = externalHolder.querySelector('[data-iframe-template]');
        if (!template) {
          return;
        }

        const iframe = template.content.firstElementChild.cloneNode(true);
        externalHolder.appendChild(iframe);
        externalHolder.dataset.loaded = 'true';
        hideOverlay();
      };

      const playNativeVideo = () => {
        if (!video) {
          return;
        }

        if (lazyLoad && video.dataset.lazyVideo === '') {
          video.load();
          delete video.dataset.lazyVideo;
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }

        hideOverlay();
      };

      if (playButton) {
        playButton.addEventListener('click', () => {
          if (externalHolder) {
            loadExternalVideo();
            return;
          }

          playNativeVideo();
        });
      }

      if (video && showOverlay === false && section.dataset.autoplay !== 'true') {
        video.addEventListener('play', hideOverlay);
      }

      if (video && lazyLoad && section.dataset.autoplay !== 'true') {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.preload = 'metadata';
                observer.unobserve(video);
              }
            });
          },
          { rootMargin: '200px' }
        );

        observer.observe(video);
      }

      if (externalHolder && section.dataset.autoplay === 'true') {
        loadExternalVideo();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
